export enum FormFieldsBoxVariant {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
}
